module.exports = __webpack_public_path__ + "static/media/hidden-component-icon.c40495cf.svg";